/* eslint-disable import/order */
import React from 'react';
import { MenuIdDashboards } from '@jira/navigation-apps__constants/src/MenuIdDashboards.tsx';
import { dashboardsDirectoryResource } from '@jira/router-resources__directories-dashboards/src/dashboardsDirectoryResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { dashboardsDirectoryRedirectRoute } from '@jira/router-routes__directories-routes/src/dashboardsDirectoryRedirectRoute.tsx';
import { ScreenRedirect } from '@jira/platform__routing-screen-redirect/src/ui/ScreenRedirect.tsx';
import { DashboardsDirectorySkeleton } from '@jira/platform__skeletons/src/ui/directories/FiltersDirectorySkeleton.tsx';
import { DashboardsDirectoryComponent, LazyDashboardsDirectory } from './ui/dashboards/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const DashboardsDirectoryRedirect = () => <ScreenRedirect to="/jira/dashboards" />;

export const dashboardsDirectoryRedirectRouteEntry: Route = createEntry(
	dashboardsDirectoryRedirectRoute,

	() => ({
		group: 'directories',
		resources: [...getNavigationResources(), dashboardsDirectoryResource],
		// eslint-disable-next-line no-restricted-syntax
		component: !__SERVER__ ? DashboardsDirectoryRedirect : DashboardsDirectoryComponent,
		skeleton: DashboardsDirectorySkeleton,
		layout: globalLayout,

		navigation: {
			menuId: MenuIdDashboards,
		},

		forPaint: [LazyAtlassianNavigation, LazyDashboardsDirectory],
		isRedirect: true,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
